import { css } from "@compiled/react";

import Lozenge from "@atlaskit/lozenge";

import { Icon } from "@/libraries/wpl/foundations/src/icon";
import { LinkModal } from "@/patterns/modal/src";

import { PlanFeatureMessage } from "../constants";

const planFeatureMessageContainerStyles = css({
    display: "flex",
    paddingInlineStart: "18px",
    paddingBlockStart: "16px",
    button: {
        "background": "none",
        "border": "none",
        "color": "#0065ff",
        "cursor": "pointer",
        "fontFamily": "Charlie Text",
        "fontSize": "16px",
        "fontWeight": 400,
        "paddingLeft": "4px",
        "textAlign": "left",
        "textDecoration": "underline",
        "textDecorationStyle": "dashed",
        "textDecorationThickness": "1px",
        "textUnderlineOffset": "3px",
        ":hover": {
            color: "#0049b0"
        }
    }
});

const noModalFeatureStyles = css({
    color: "#091e42",
    paddingInlineStart: "4px"
});

const PlanFeature = ({ featureMessage, lozengeText }: PlanFeatureMessage) => {
    const isLinkPropsType = !(typeof featureMessage === "string");

    return (
        <div css={planFeatureMessageContainerStyles}>
            <Icon name="featurecheckmark" size="xs" color="#00875a" />

            <div css={noModalFeatureStyles}>
                {isLinkPropsType ? (
                    <LinkModal {...featureMessage} />
                ) : (
                    featureMessage
                )}
                {lozengeText && <Lozenge>{lozengeText}</Lozenge>}
            </div>
        </div>
    );
};

export { PlanFeature };
